module.exports = __webpack_public_path__ + "assets/img/Corner Group.3447989a.png";